import React from "react";
import { Layers } from "lucide-react";

export default function BlindStructureCard({ structure }) {
  if (!structure) return null;
  const lines = (structure.levels || "").split("\n").map((l) => l.trim()).filter(Boolean);
  let level = 0;
  const rows = lines.map((l) => (/break|colou?r.?up/i.test(l) ? { brk: true, text: l } : { n: ++level, text: l }));
  return (
    <div data-testid="event-blind-structure-card">
      <h2 className="font-display text-2xl font-bold text-white mb-1 flex items-center gap-2"><Layers className="w-5 h-5 text-gold" /> Blind Structure</h2>
      <p className="text-gold text-sm" data-testid="event-blind-structure-name">{structure.name}</p>
      {structure.description && <p className="text-slate-400 text-sm mt-1">{structure.description}</p>}
      {rows.length > 0 && (
        <div className="mt-4 border border-white/10 overflow-hidden">
          <table className="w-full text-left text-sm" data-testid="event-blind-levels">
            <thead className="bg-secondary text-gold text-xs uppercase tracking-wider">
              <tr><th className="px-5 py-3 w-24">Level</th><th className="px-5 py-3">Blinds</th></tr>
            </thead>
            <tbody>
              {rows.map((r, i) => r.brk ? (
                <tr key={i} className="border-t border-white/5 bg-gold/10"><td colSpan={2} className="px-5 py-2 text-gold text-xs font-bold uppercase tracking-widest text-center">{r.text}</td></tr>
              ) : (
                <tr key={i} className="border-t border-white/5 hover:bg-white/5"><td className="px-5 py-2.5 text-slate-400">{r.n}</td><td className="px-5 py-2.5 text-white font-mono">{r.text}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
